<template>
  <div>
    <iframe
      v-if="videoId"
      :id="iframeId"
      :src="getVideoUrl()"
      :width="playerWidth"
      :height="playerHeight"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      video-type="video_type.vimeo"
    />
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      default: ''
    },
    playerWidth: {
      type: Number,
      default: undefined
    },
    playerHeight: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      iframeId: 'my-vimeo-player-' + this._uid
    }
  },
  mounted() {
    this.iframe = document.getElementById(this.iframeId)
    window.loadScript('https://player.vimeo.com/api/player.js', () => {
      this.player = new window.Vimeo.Player(this.iframe)
      this.player.on('ended', () => {
        this.$emit('ended')
      })
    })
  },
  methods: {
    getVideoUrl() {
      let videoId = this.videoId
      if (videoId.startsWith('http')) {
        videoId = videoId.replace('https://vimeo.com/', '')
        if (videoId.indexOf('/') > 0) {
          videoId = videoId.substring(0, videoId.indexOf('/'))
        }
      }
      return 'https://player.vimeo.com/video/' + videoId
    }
  }
}
</script>
